'use client';
import {
  IFinancingOfferCampaign,
  ICampaignRemainingCost,
  IFinancingOfferFormatted,
} from '~/interfaces/synchrony/synchrony-interfaces';
import { LearnHowLink } from './learn-how-link';
import { useState } from 'react';
import {
  //   TODO:: IN STORE Offers - LIMITED
  //   LimitedTimeFinancingOfferViewModel_SpecialCampaignOffer,
  SynchronyConfiguration,
} from '~/gql/__generated__/types';
import { handleSynchronyLearnHowTealium } from '~/utils/tealium/tealium-utag-link-events';
import { getLowCostOffer } from '~/modules/payment/synchrony/utils/get-financing-offer-details';
import { SynchronyModal } from '~/modules/payment/synchrony/components/modal/synchrony-modal';
import { ISalesOrderResponse } from '~/interfaces/get-sales-order';
import { TYPES, WMAP_PREFIX } from '~/modules/payment/constants';
import { generateCSId } from '~/utils/utils';
import { useSelectedPaymentOption } from '~/store/wmap-store';
import styles from '../buy-now-pay-later-options.module.scss';
import { IPaymentState } from '~/interfaces/payment';
import CustomSkeleton from '~/components/custom-skeleton';

export const learnHowCtaText = 'Learn more';
type props = {
  selectedOffer: IFinancingOfferFormatted;
  campaign:
    | IFinancingOfferCampaign
    //   TODO:: IN STORE Offers - LIMITED
    // | LimitedTimeFinancingOfferViewModel_SpecialCampaignOffer
    | undefined;
  campaignRemainingCost: ICampaignRemainingCost | undefined;
  bspConfigs: SynchronyConfiguration;
  cart: ISalesOrderResponse;
  learnHowCtaNameForCashback?: string;
  activeTab?: number;
  progressiveTotalAmount?: number;
  ctaType?: string;
  isExtraPromoEligible?: boolean;
  paymentState?: IPaymentState;
  enableMSChat?: boolean;
  isOfferLoading?: boolean;
};
const SynchronyLearnHow: React.FC<props> = ({
  selectedOffer,
  campaign,
  campaignRemainingCost,
  bspConfigs,
  cart,
  learnHowCtaNameForCashback,
  activeTab,
  progressiveTotalAmount,
  ctaType,
  isExtraPromoEligible,
  paymentState,
  enableMSChat,
  isOfferLoading,
}) => {
  const syfPruchaseRulesConfig = bspConfigs?.synchronyFinancingPurchaseRules;
  const financingOffersConfig = bspConfigs?.financingOffers;

  const [isOpen, setIsOpen] = useState(false);

  const toggleSynchronyModal = () => {
    if (!isOpen) {
      handleSynchronyLearnHowTealium();
    }
    setIsOpen(!isOpen);
  };

  const selectedPaymentMethod = useSelectedPaymentOption();
  const isProgressive = selectedPaymentMethod === TYPES.PROGRESIVE;
  const isAffirm = ctaType === 'affirm';
  //   TODO:: IN STORE Offers - LIMITED
  //   const { limitedFinancingOfferMessage } = selectedOffer;
  const costPerMonth = selectedOffer.costPerMonth ?? 0;

  const selectedOfferForModal =
    !campaign &&
    !campaignRemainingCost &&
    //   TODO:: IN STORE Offers - LIMITED
    // !limitedFinancingOfferMessage &&
    costPerMonth <
      (syfPruchaseRulesConfig?.minimumMonthlyPurchaseThreshold || 0)
      ? getLowCostOffer(
          financingOffersConfig?.lowCostFinancingOffer,
          syfPruchaseRulesConfig?.losCostOfferName ?? '',
          selectedOffer?.numOfMonths,
        )
      : selectedOffer;

  const learnHowCtaId = (() => {
    const type = (ctaType || '').toLowerCase();
    switch (type) {
      case TYPES.PROGRESIVE.toLowerCase():
        return `${WMAP_PREFIX}-progressive-learn-how-btn`;
      case TYPES.AFFIRM.toLowerCase():
        return `${WMAP_PREFIX}-affirm-learn-how-btn`;
      case TYPES.SYNCHRONY.toLowerCase():
      default:
        return generateCSId(
          `${WMAP_PREFIX}-learn-more`,
          selectedOffer?.offerName,
        );
    }
  })();
  return (
    <>
      {isOfferLoading ? (
        <CustomSkeleton type="text" height="25" width="90" />
      ) : (
        <LearnHowLink toggleModal={toggleSynchronyModal} id={learnHowCtaId}>
          {isProgressive ? (
            <span className={styles.progressiveCtaText}>Learn How</span>
          ) : (
            <span className={isAffirm ? styles.affirmCtaText : ''}>
              {learnHowCtaNameForCashback || learnHowCtaText}
            </span>
          )}
        </LearnHowLink>
      )}
      <SynchronyModal
        isOpen={isOpen}
        toggleSynchronyModal={toggleSynchronyModal}
        selectedOffer={selectedOfferForModal}
        bspConfigs={bspConfigs}
        cart={cart}
        activeTab={activeTab}
        progressiveTotalAmount={progressiveTotalAmount}
        isExtraPromoEligible={isExtraPromoEligible}
        paymentState={paymentState}
        enableMSChat={enableMSChat}
      />
    </>
  );
};

export default SynchronyLearnHow;
